document.addEventListener('DOMContentLoaded', function(){
  const faqSection = document.querySelector('.custom-offers-faq');
  if (!faqSection) return;

  const offerItems = faqSection.querySelectorAll('.offer-item');

  offerItems.forEach(item => {
    const btn = item.querySelector('.toggle-btn');
    const content = item.querySelector('.offer-content');
    const codeBox = content.querySelector('.code-box');

    // Only add toggle event if codeBox exists
    if (codeBox) {
      btn.addEventListener('click', () => {
        const isShown = content.classList.contains('show');
        // Collapse all
        offerItems.forEach(i => {
          i.querySelector('.offer-content').classList.remove('show');
          i.querySelector('.toggle-btn').textContent = '+';
        });
        // Toggle current
        if (!isShown) {
          content.classList.add('show');
          btn.textContent = '–';
        } else {
          content.classList.remove('show');
          btn.textContent = '+';
        }
      });
    } else {
      // If no code, hide toggle button completely
      btn.style.display = 'none';
    }
  });

  // Copy code functionality
  const copyBtns = faqSection.querySelectorAll('.copy-btn');
  copyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const code = btn.previousElementSibling.textContent;
      navigator.clipboard.writeText(code);
      btn.textContent = "Copied!";
      setTimeout(() => btn.textContent = "Copy Code", 1500);
    });
  });

  // More offers toggle with slide
  const moreBtn = faqSection.querySelector('.more-offers');
  const hiddenOffers = faqSection.querySelectorAll('.hidden-offer');
  let offersShown = 0;

  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      if (offersShown < hiddenOffers.length) {
        hiddenOffers[offersShown].classList.add('show');
        offersShown++;
        const remaining = hiddenOffers.length - offersShown;
        moreBtn.textContent = remaining > 0 ? `+${remaining} more offers` : "Show less";
      } else {
        // Hide all hidden offers
        hiddenOffers.forEach(h => h.classList.remove('show'));
        offersShown = 0;
        moreBtn.textContent = `+${hiddenOffers.length} more offers`;
      }
    });
  }
});


  $('#PBarNextFrame').attr('title', 'figma');

